import { Store } from "lucide-react";

const storeLabel = (s) => [s.tw_dc || s.store_id, s.name, s.city].filter(Boolean).join(" · ");

// value: null = all stores (incl. stores added later), array = only these location ids
export const EmployeeStoreAccess = ({ stores, value, onChange }) => {
  const all = value === null || value === undefined;
  const ids = all ? stores.map((s) => s.id) : value;
  const toggle = (id) => onChange(ids.includes(id) ? ids.filter((x) => x !== id) : [...ids, id]);
  return (
    <div className="space-y-2" data-testid="emp-store-access">
      <div className="flex items-center gap-2 text-sm font-medium text-navy"><Store className="w-4 h-4 text-teal" /> Store access</div>
      <label className="flex items-center gap-2 text-sm cursor-pointer">
        <input type="checkbox" checked={all} onChange={(e) => onChange(e.target.checked ? null : stores.map((s) => s.id))}
          className="rounded border-slate-300 text-teal focus:ring-teal" data-testid="emp-store-all" />
        <span>All stores (including stores added later)</span>
      </label>
      {!all && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-1.5 max-h-48 overflow-y-auto border border-slate-100 rounded-md p-2">
          {stores.length === 0 && <p className="text-xs text-slate-400">No stores assigned to this dealer yet.</p>}
          {stores.map((s) => (
            <label key={s.id} className="flex items-center gap-2 text-xs cursor-pointer">
              <input type="checkbox" checked={ids.includes(s.id)} onChange={() => toggle(s.id)}
                className="rounded border-slate-300 text-teal focus:ring-teal" data-testid={`emp-store-${s.id}`} />
              <span className="truncate">{storeLabel(s)}</span>
            </label>
          ))}
        </div>
      )}
      <p className="text-[11px] text-slate-400">Limits Dashboard, Dealer Sales, My Locations, Visits and other tabs to these stores.</p>
    </div>
  );
};
